import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ContenutiCorsoService {

    static createContenuto = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static deleteContenuto = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti/delete`;
            ApiService.delete(resolve, reject, url, data)
        });
    }

    static updateContenuto = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    }

    static findContenuti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti/find`;
            ApiService.postRudeRequest(resolve, reject, url, data)
        });
    }

    static cloneContenuti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti/clone`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

}